import { Link } from "react-router-dom";
import { openCookiePreferences } from "../lib/cookieConsent";

export default function Footer() {
  return (
    <footer className="bg-lokaso-dark text-lokaso-sand mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="flex items-center gap-2">
            <span className="lokaso-flag-stripe h-7"><span /><span /><span /></span>
            <span className="font-display text-2xl font-extrabold">LOKASO</span>
          </div>
          <p className="mt-3 text-sm text-white/70 max-w-xs">
            L'annuaire de référence des entreprises en Guinée. Trouvez les meilleurs services près de chez vous.
          </p>
        </div>

        <div>
          <h4 className="font-display text-lg mb-3 text-lokaso-gold">Explorer</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/search?category=restaurants" className="hover:text-lokaso-gold">Restaurants</Link></li>
            <li><Link to="/search?category=hotels" className="hover:text-lokaso-gold">Hôtels</Link></li>
            <li><Link to="/search?category=sante" className="hover:text-lokaso-gold">Santé</Link></li>
            <li><Link to="/search?category=banques" className="hover:text-lokaso-gold">Banques</Link></li>
            <li><Link to="/app" className="hover:text-lokaso-gold font-semibold" data-testid="footer-link-install-app">📲 Installer l'appli</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-3 text-lokaso-gold">Entreprises</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/business/register" className="hover:text-lokaso-gold">Inscrire mon entreprise</Link></li>
            <li><Link to="/dashboard" className="hover:text-lokaso-gold">Tableau de bord</Link></li>
            <li><Link to="/login" className="hover:text-lokaso-gold">Se connecter</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-3 text-lokaso-gold">Légal</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li><Link to="/faq" className="hover:text-lokaso-gold" data-testid="footer-link-faq">FAQ</Link></li>
            <li><Link to="/politique-confidentialite" className="hover:text-lokaso-gold" data-testid="footer-link-privacy">Politique de confidentialité</Link></li>
            <li><Link to="/conditions-utilisation" className="hover:text-lokaso-gold" data-testid="footer-link-terms">Conditions d'utilisation</Link></li>
            <li><Link to="/politique-cookies" className="hover:text-lokaso-gold" data-testid="footer-link-cookies">Politique de cookies</Link></li>
            <li>
              <button
                type="button"
                onClick={openCookiePreferences}
                className="text-left hover:text-lokaso-gold"
                data-testid="footer-manage-cookies"
              >
                Gérer les cookies
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg mb-3 text-lokaso-gold">À propos</h4>
          <ul className="space-y-2 text-sm text-white/80">
            <li>Conakry, Guinée</li>
            <li>
              <a href="mailto:admin@lokasos.com" className="hover:text-lokaso-gold transition-colors" data-testid="footer-email">
                admin@lokasos.com
              </a>
            </li>
            <li>
              <a href="https://wa.me/12402859605" target="_blank" rel="noreferrer" className="hover:text-lokaso-gold transition-colors" data-testid="footer-whatsapp">
                +1 240-285-9605
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-white/60">
        © 2025 Lokaso. Fait avec <span className="text-lokaso-red">♥</span> en Guinée.
      </div>
    </footer>
  );
}
